<template>
  <div class="feed-good" @click="goDetail">
    <div class="image-wrapper">
      <GoodImage
        class="good-image"
        :img-url="
          (good.img_url || goodDefaultImg)
            | ossImage(500, 500, 'contain')
            | ossHttpVersion
        "
        :fit="'contain'"
      ></GoodImage>
    </div>
    <div class="title">
      <span v-if="good.pop_type === 1" class="self-support-tag">自营</span>
      <span class="name">{{ good.name }}</span>
    </div>
    <span class="format">{{ formatInfo }}</span>
    <!-- 非价格保护 -->
    <div v-if="!ssuInfo.price_shield" class="price">
      <span class="price-symbol">{{ priceInfo.priceSymbol }}</span>
      <span class="price-value">{{ priceInfo.priceValue }}</span>
      <span class="price-unit">/{{ priceInfo.priceUnit }}</span>
      <span v-if="originalPrice" class="original-price">{{
        originalPrice
      }}</span>
      <div class="operator-wrap">
        <new-operator
          use-simple
          show-simple-count
          :ssu="good.ssu_list[0]"
          :is-hint="good.is_hint"
          @add="addTick"
          @subscribe="subscribeTick"
          @goDetail="goDetail"
        />
      </div>
    </div>
    <!-- 价格保护 -->
    <div v-else class="price-shield-text">
      {{ ssuInfo.shield_text }}
    </div>

    <div v-if="Array.isArray(good.tags_list)" class="tags">
      <tag
        v-for="tag in good.tags_list"
        :key="tag.tag"
        has-border
        has-background
        :primary-color="tag.text_color"
        :secondary-color="tag.frame_color"
        :corner-radius="tag.corner_radius"
        :bg-color="tag.background_color"
      >
        {{ tag.tag }}
      </tag>
    </div>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import NewOperator from '@/common/widgets/newOperator'
import Tag from '@/common/widgets/good_tag'
import GoodImage from '@/common/widget/GoodImage/index.vue'
import oftenBuyImg from '@/images/cms/feed/often_buy.png'
import popularHotImg from '@/images/cms/feed/popular_hot.png'
import freshArrivalImg from '@/images/cms/feed/fresh_arrival.png'
import haveSeeImg from '@/images/cms/feed/have_see.png'
import { goodDefaultImg } from '@/defines/environment/config'

const recommendTagMap = {
  0: oftenBuyImg,
  1: popularHotImg,
  2: freshArrivalImg,
  3: haveSeeImg
}

export default {
  components: {
    NewOperator,
    Tag,
    GoodImage
  },
  props: {
    good: {
      type: Object,
      default: () => {}
    },
    skuIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      goodDefaultImg,
      recommendTagMap
    }
  },
  computed: {
    ssuInfo() {
      const { ssu_list = [{}] } = this.good
      return ssu_list[0]
    },
    promoteTagPics() {
      const tagPics = this.ssuInfo.promote_tag_pics || []
      return tagPics.slice(0, 2)
    },
    recommendTag() {
      const recommendLabel = this.good.recommend_info || {}
      const recommendTag =
        recommendLabel !== undefined ? this.recommendTagMap[recommendLabel] : ''
      return recommendTag
    },
    formatInfo() {
      // 前置单位描述
      const preUnitText =
        this.ssuInfo.total_price_include_package !== this.ssuInfo.unit_price
          ? '¥' +
            this.ssuInfo.total_price_include_package +
            '/' +
            this.ssuInfo.total_format
          : '每' + this.ssuInfo.total_format
      // 前置押金信息
      const preDepositMsg = this.ssuInfo.preposition_deposit_msg || ''
      return preUnitText + preDepositMsg
    },
    priceInfo() {
      const isShowWeightUnitPrice = this.ssuInfo.is_show_weight_unit_price || 0
      const shouldShowWeightUnitPrice = Number(isShowWeightUnitPrice) === 1
      return {
        priceSymbol: shouldShowWeightUnitPrice ? '约¥' : '¥',
        priceValue: shouldShowWeightUnitPrice
          ? this.ssuInfo.weight_unit_price
          : this.ssuInfo.unit_price,
        priceUnit: shouldShowWeightUnitPrice
          ? this.ssuInfo.weight_price_unit
          : this.ssuInfo.price_unit
      }
    },
    originalPrice() {
      const isShowWeightUnitPrice = this.ssuInfo.is_show_weight_unit_price || 0
      const shouldShowWeightUnitPrice = Number(isShowWeightUnitPrice) === 1
      const promoteType = this.ssuInfo.promote_type || []

      const hasPromote =
        promoteType.includes(2) || // 普通商品2和购物车3是一个东西
        promoteType.includes(3) ||
        promoteType.includes(4) ||
        promoteType.includes(21) || // 会员价（标签展示），新增类型
        promoteType.includes(12)

      return hasPromote
        ? shouldShowWeightUnitPrice
          ? `¥${this.ssuInfo.weight_original_unit_price}`
          : `¥${this.ssuInfo.original_unit_price}`
        : ''
    }
  },
  methods: {
    // 去商品详情
    goDetail() {
      this.$emit('onTick', { type: 'go-detail' }, { ssu: this.ssuInfo })

      // 跳商品详情拼接tickReferId
      const spm = this.$trackMap.cmsModule.feedGoodsGoDetail
      const tickReferId = `${spm}.${this.skuIndex}`

      this.$nativeRedirect(this.$nativeRoutes.goodsDetail, {
        id: this.ssuInfo.ssu_id,
        tickReferId
      })
    },
    addTick() {
      this.$emit('onTick', { type: 'add-goods' }, { ssu: this.ssuInfo })
    },
    subscribeTick() {
      this.$emit('onTick', { type: 'subscribe-goods' }, { ssu: this.ssuInfo })
    },
    goodShopTrack() {
      this.$emit(
        'onTick',
        { type: 'go-pop' },
        { ssu: this.ssuInfo, skuPos: this.skuIndex }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.feed-good {
  box-sizing: border-box;

  position: relative;

  width: 3.48rem;
  min-height: 5.56rem;
  margin-bottom: 0.12rem;
  padding: 0.3rem 0.2rem 0 0.2rem;
  overflow: hidden;

  background-color: #fff;

  border-radius: 0.12rem;

  .image-wrapper {
    display: block;

    position: relative;

    width: 3rem;
    height: 3.2rem;
    margin: 0 auto;

    .good-image {
      display: block;

      width: 3rem;
      height: 3.2rem;
      margin: 0 auto;
    }

    .good-lock-info {
      position: absolute;
      bottom: 0;
      left: 0;

      width: 3rem;
    }

    .promote-tag-pic {
      display: block;

      position: absolute;
      top: 0;
      left: 0;

      width: 3rem;
      height: 3.2rem;
    }

    .recommend-tag {
      position: absolute;
      right: -0.04rem;
      bottom: 0;

      width: 1.28rem;
      height: 0.44rem;
    }
  }

  .title {
    padding-top: 0.2rem;

    border-top: 0.01rem solid #f6f6f6;

    @include flex(row, flex-start, center, nowrap);

    .self-support-tag {
      width: 0.6rem;
      margin-right: 0.1rem;
      padding: 0.06rem 0;

      border-radius: 0.04rem;

      border: 0.01rem solid #8bddad;

      flex: none;

      font-size: 0.22rem;
      text-align: center;
      white-space: nowrap;

      color: #15bb5c;
    }

    .name {
      overflow: hidden;

      flex: auto;

      font-size: 0.26rem;
      line-height: 0.28rem;
      font-weight: 500;
      white-space: nowrap;

      color: #333;
      text-overflow: ellipsis;
    }
  }

  .format {
    display: block;

    width: 3rem;
    margin-top: 0.18rem;

    font-size: 0.22rem;
    line-height: 0.24rem;

    color: #999;
    @include text-overflow-ellipsis-single;
  }

  .price {
    position: relative;

    margin-top: 0.24rem;

    .price-symbol {
      font-size: 0.22rem;
      color: #ff614a;
    }
    .price-value {
      font-size: 0.3rem;
      font-weight: 500;
      color: #ff614a;
    }
    .price-unit {
      font-size: 0.2rem;
      color: #999;
    }
    .original-price {
      font-size: 0.2rem;
      text-decoration: line-through;
      color: #999;
    }
    .operator-wrap {
      position: absolute;
      right: 0;
      bottom: -0.14rem;
    }
  }

  .price-shield-text {
    display: block;

    margin-top: 0.32rem;

    font-size: 0.22rem;

    color: #999;
  }

  .tags {
    margin-top: 0.1rem;

    @include flex(row, flex-start, flex-start, wrap);

    ::v-deep .good-tag {
      margin: 0 5px 5px 0;

      flex: none;
    }
  }
}
</style>
